import { render, staticRenderFns } from "./en_fwtk.vue?vue&type=template&id=3364c9d4&scoped=true"
import script from "./en_fwtk.vue?vue&type=script&lang=js"
export * from "./en_fwtk.vue?vue&type=script&lang=js"
import style0 from "./en_fwtk.vue?vue&type=style&index=0&id=3364c9d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3364c9d4",
  null
  
)

export default component.exports